const extractPerUnitPrices = (data) => {
  return data
    .map((product) => {
      return {
        product: product?.product_id,
        name: product?.product_name,
        monthlyQuota: product?.product_metadata?.quota,
        isSubscribed: product?.is_subscribed,
        isFreePlan: product?.product_metadata?.free_plan,
        description: product?.product_description,
      };
    })
    .filter((price) => price !== null);
};

const PRODUCT_NAMES = {
  unstract: "unstract",
  llmWhisperer: "llm-whisperer",
  verticals: "verticals",
};

const SELECTED_PRODUCT = "selectedProduct";

const LLM_WHISPERER_ENDPOINT = "/api/v1/llmwhisperer";

export {
  extractPerUnitPrices,
  PRODUCT_NAMES,
  SELECTED_PRODUCT,
  LLM_WHISPERER_ENDPOINT,
};
